var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKycFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 3.40419V9.6C21 10.4401 21 10.8601 21.1635 11.181C21.3073 11.4632 21.5368 11.6927 21.819 11.8365C22.1399 12 22.5599 12 23.4 12H29.5958M30 14.9823V25.8C30 28.3202 30 29.5804 29.5095 30.543C29.0781 31.3897 28.3897 32.0781 27.543 32.5095C26.5804 33 25.3202 33 22.8 33H13.2C10.6798 33 9.41965 33 8.45704 32.5095C7.61031 32.0781 6.9219 31.3897 6.49047 30.543C6 29.5804 6 28.3202 6 25.8V10.2C6 7.67976 6 6.41965 6.49047 5.45704C6.9219 4.61031 7.61031 3.9219 8.45704 3.49047C9.41965 3 10.6798 3 13.2 3H18.0177C19.1183 3 19.6686 3 20.1865 3.12434C20.6457 3.23457 21.0847 3.41639 21.4873 3.66312C21.9414 3.94141 22.3305 4.33055 23.1088 5.10883L27.8912 9.89117C28.6695 10.6695 29.0586 11.0586 29.3369 11.5127C29.5836 11.9153 29.7654 12.3543 29.8757 12.8135C30 13.3314 30 13.8817 30 14.9823Z",
    stroke: "#963A72",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKycFile);
export default __webpack_public_path__ + "static/media/kyc-file.fd77a459891f8177bba5e2110cc1a69f.svg";
export { ForwardRef as ReactComponent };